import React from "react";
import Nav from "./nav";
import SidebarTwo from "./Sidebar2";
import OverviewBatteries from "./OverviewBattery";
import ClientBatteries from "./ClientBatteries";
import { useContext } from "react";
import { MyContext } from "../../context";
import ClientSidebar from "./ClientSidebar";
import ClientInstallation from "./ClientInstallation";
import ClientOverview from "./ClientOverview";
import ClientReport from "./ClientReport"
import ClientSetting from "./ClientSetting"

function ClientDashboard() {
  const { LinkSelection } = useContext(MyContext);

  let SideBarLink = () => {
    switch (LinkSelection) {
      case "":
        return (
          <>
            <ClientOverview />
          </>
        );
        break;

      case "Clients":
        return (
          <>
            <ClientInstallation />
          </>
        );
        break;

      case "Battery":
        return (
          <>
            <ClientBatteries />
          </>
        );
        break;

        case "Report":
        return (
          <>
            <ClientReport />
          </>
        );
        break;

        case "Setting":
        return (
          <>
            <ClientSetting />
          </>
        );
        break;

        

        
    }
  };

  return (
    <>
      <Nav />
      <div className="wrap">
        <div className="sideWrap">
          <ClientSidebar />
        </div>

        <div className="contentWrap" style={{ width: "100%" }}>
          {SideBarLink()}
        </div>
      </div>
    </>
  );
}

export default ClientDashboard;
